export const state = {
  map: null,
  markers: [],
  initialBounds: null,
  boundaryLayer: null,
  bounds: L.latLngBounds([]),
  navigationActivated: false,
  startPoint: null,
  endPoint: null,
  routeLayer: null,
  tempStartMarker: null,
  tempEndMarker: null,
  userLocationMarker: null,
};

// Initialize state with proper validation
export function initState() {
  console.log("🔧 Initializing location-list state");

  // Ensure markers array is initialized
  if (!state.markers) {
    state.markers = [];
  }

  // Ensure bounds is initialized
  if (!state.bounds) {
    state.bounds = L.latLngBounds([]);
  }

  console.log("✅ State initialized. Markers array length:", state.markers.length);
}

export const els = {
  mapElement: null,
  loadingIndicator: null,
  industryInfo: null,
  industries: null,
  provinceInfoFull: null,
  registerForm: null,
  navMess: null,
};

export function initEls() {
  els.mapElement = document.getElementById("osm-wrapper");
  if (!els.mapElement) return; // Stop if main element doesn't exist

  els.loadingIndicator = document.getElementById("loading-indicator");
  els.industryInfo = document.getElementById("industry-detail");
  els.industries = document.getElementById("industries");
  els.provinceInfoFull = document.getElementById("province-info-full");
  els.registerForm = document.getElementById("register-form");
  els.navMess = document.getElementById("navigation-message");
}

export function setMap(mapInstance) {
  state.map = mapInstance;
  // Expose to global scope for debugging
  window.locationListMap = mapInstance;
  console.log("Map instance stored in state and global scope"); // Debug log
}
